import * as React from "react";
import { Grid, Box, Stack, Button, Chip, IconButton } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import dayjs from "dayjs";
import Search from "../Components/Search";
import Layout from "../Components/Layout";
import { ApiManager } from "../Services/Networking";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Edit, Trash } from "lucide-react";

export default function Holiday() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchText, setSearchText] = React.useState("");
  const [holidays, setHolidays] = React.useState(
    location.state?.updatedList || [],
  );
  const [loading, setLoading] = React.useState(!location.state?.updatedList);

  useEffect(() => {
    if (location.state?.updatedList) {
      setHolidays(location.state.updatedList);
      setLoading(false);
    } else {
      fetchData();
    }
  }, [location.state?.updatedList]);

  const fetchData = async () => {
    setLoading(true);
    const res = await ApiManager.getHolidays();
    if (res.status === "success") setHolidays(res.data);
    setLoading(false);
  };

  const filteredRows = holidays.filter((row) =>
    row.name.toLowerCase().includes(searchText.toLowerCase()),
  );

  const DeleteHoliday = async (id) => {
    if (window.confirm("Are you sure you want to delete this holiday?")) {
      setLoading(true);
      const res = await ApiManager.deleteHoliday(id);
      if (res.status === "success") {
        setHolidays((prev) => prev.filter((h) => h.id !== id));
      }
      setLoading(false);
    }
  };

  const columns = [
    { field: "name", headerName: "Holiday Name", flex: 1.5, minWidth: 200 },
    {
      field: "from_date",
      headerName: "From",
      flex: 1,
      minWidth: 150,
      valueFormatter: (params) => dayjs(params).format("DD MMM YYYY"),
    },
    {
      field: "to_date",
      headerName: "To",
      flex: 1,
      minWidth: 150,
      valueFormatter: (params) => dayjs(params).format("DD MMM YYYY"),
    },
    {
      field: "holiday_type",
      headerName: "Type",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => (
        <Chip
          label={params.value}
          color={params.value === "National" ? "primary" : "default"}
          size="small"
        />
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      minWidth: 100,
      flex: 0.6,
      renderCell: (params) => (
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
          spacing={1}
          padding={2}
          paddingLeft={0}
        >
          <IconButton
            onClick={() =>
              navigate("/holiday/form", {
                state: { holiday: params.row, fullList: holidays },
              })
            }
          >
            <Edit size={18} />
          </IconButton>

          <IconButton onClick={() => DeleteHoliday(params.row.id)}>
            <Trash size={18} />
          </IconButton>
        </Stack>
      ),
    },
  ];

  return (
    <Layout name="HOLIDAY">
      <Grid container spacing={2} columns={12}>
        <Grid size={{ xs: 12 }}>
          <Stack direction="row" spacing={2} alignItems="center">
            <Search
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
            <span style={{ flex: 1 }}></span>
            <Button
              variant="contained"
              onClick={() =>
                navigate("/holiday/form", {
                  state: { holiday: null, fullList: holidays },
                })
              }
            >
              Create New
            </Button>
          </Stack>
        </Grid>
        <Grid size={{ xs: 12 }} style={{ minHeight: "580px" }}>
          <Box sx={{ height: 600 }}>
            <DataGrid
              rows={filteredRows}
              columns={columns}
              rowHeight={70}
              loading={loading}
              getRowId={(row) => row.id}
              pageSizeOptions={[10, 20, 50]}
              initialState={{
                pagination: { paginationModel: { pageSize: 10 } },
              }}
              disableRowSelectionOnClick
            />
          </Box>
        </Grid>
      </Grid>
    </Layout>
  );
}
